import React, { useState, useEffect } from "react";
import styles from "styles/genai/Edetail.module.scss";

import component1 from "img/genai/images/component1.png";
import component2 from "img/genai/images/component2.png";

import { SlideTabs, SlideTabsControl } from "./slides/SlideTabs";
import { PreviewToggle } from "./slides/PreviewToggle";
import { ShowSlideImgNew } from "./slides/ShowSlideImg";
import moduleimage from "img/genai/modulepic.svg";
import ModulePreviewData from "components/modules/ModulePreviewData";
import { classifySlideAssets, getAllModules } from "../api/genapi";
import { Spinner, Modal, Button } from "react-bootstrap";
import CustomModal from "components/customModal";
import ConfirmationPopup from "components/ConfirmationPopup";
// import { datasource } from "../utils/sampledata.json";
import CircularProgressBar from "Uitls/CircularProgressBar";
import PrimaryButton from "components/PrimaryButton";
const slideDataCache = window.slideDataCache || {};

const ElementPreviewSlidesComponent = ({
  show,
  onClose,
  setAnalyseModal,
  modulesData,
  selectedSlide,
}) => {
  const [activeSlideId, setActiveSlideId] = React.useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = React.useState(false);
  const [currentSlideId, setCurrentSlideId] = React.useState(null);
  const [validSlides, setValidSlides] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [currentSlideIndex, setCurrentSlideIndex] = React.useState(0);

  React.useEffect(() => {
    if (!show) {
      setIsLoading(true);
      setActiveSlideId(null);
      return;
    }

    if (!selectedSlide || !selectedSlide.slideIds || !modulesData) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const slideIdToModuleMap = {};
    modulesData.forEach((mod) => {
      slideIdToModuleMap[mod.slideId] = mod;
    });

    const filteredSlides = selectedSlide.slideIds
      .map((slideId, index) => {
        const module = slideIdToModuleMap[slideId];
        if (!module) return null;

        return {
          name: selectedSlide.slidenums?.[index] || `Slide ${index + 1}`,
          id: slideId,
          signedUrl:
            selectedSlide.signedUrls?.find((url) => url.pageId === slideId)
              ?.signedUrl || null,
          moduleData: module.moduleData,
        };
      })
      .filter(Boolean);

    setValidSlides(filteredSlides);

    if (filteredSlides.length > 0) {
      setActiveSlideId(filteredSlides[0].id);
      setCurrentSlideId(filteredSlides[0].id);
      setCurrentSlideIndex(0);
    }

    setIsLoading(false);
  }, [show, modulesData, selectedSlide]);

  // Update currentSlideIndex when activeSlideId changes
  React.useEffect(() => {
    if (activeSlideId && validSlides.length > 0) {
      const index = validSlides.findIndex(
        (slide) => slide.id === activeSlideId,
      );
      if (index >= 0) {
        setCurrentSlideIndex(index);
      }
    }
  }, [activeSlideId, validSlides]);

  // Don't render anything if not shown
  if (!show) return null;

  const handlePreviewToggle = () => {
    setIsPreviewOpen((prev) => !prev);
    setCurrentSlideId(activeSlideId);
  };

  const currentSlide = validSlides[currentSlideIndex];

  // Handle slide tab click
  const handleSlideClick = (slideId, index) => {
    if (!isLoading) {
      setActiveSlideId(slideId);
      setCurrentSlideIndex(index);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={() => {}}>
      <div
        className={styles.modalContent}
        style={{ width: "1085px" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <article className={styles.modalHead}>
          {validSlides.length > 0 ? (
            <div
              className={`${styles.MEMHeadBox} ${styles.elemMEM}`}
              style={{ borderBottom: "none" }}
            >
              <span>SELECTED SLIDES</span>
              <PreviewToggle
                isActive={isPreviewOpen}
                onToggle={handlePreviewToggle}
              />
            </div>
          ) : (
            <div className="p-3 text-center">
              <span className="text-muted">No slides available</span>
            </div>
          )}
        </article>

        {/* Main content area - Left-Right Layout */}
        {isLoading || validSlides.length === 0 ? (
          <div className={styles.loaderContainer}>
            <CircularProgressBar isloading={true} />
          </div>
        ) : (
          <div className={styles.MEMBoxMain}>
            {/* Left side - Slide tabs */}
            <div className={styles.leftMEM} style={{ padding: 0 }}>
              {validSlides.length > 0 && (
                <div className={styles.contASlideAnalyse}>
                  {validSlides.map((slide, index) => {
                    const isSelected = activeSlideId === slide.id;
                    const slideName = slide.name;

                    return (
                      <div
                        key={slide.id}
                        className={`${styles.fullBOX} ${
                          isSelected ? styles.selectedSlide : ""
                        }`}
                        onClick={() => handleSlideClick(slide.id, index)}
                      >
                        <div
                          className={`${styles.sliderecBoxAnalyse} ${styles.elemSection} ${
                            isSelected ? styles.activeModule : ""
                          }`}
                        >
                          <span className={styles.analyseboxOne}>
                            <img
                              src={slide.signedUrl}
                              alt={`${slideName} thumbnail`}
                              className={styles.imgSlideAnalyse}
                              onError={(e) => {
                                e.target.style.display = "none";
                                const placeholder =
                                  document.createElement("div");
                                placeholder.className =
                                  styles.thumbnailPlaceholder;
                                placeholder.textContent = slideName.charAt(0);
                                e.target.parentElement.appendChild(placeholder);
                              }}
                            />
                            <span className={styles.analyseTextMEM}>
                              {slideName}
                            </span>
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Right side - Slide preview */}
            <div className={styles.rightMEM} style={{ padding: 0 }}>
              <div className={styles.cmsdouterpreviewBox}>
                {isPreviewOpen ? (
                  <div className={styles.rightMEM}>
                    <ShowSlideImgNew
                      slideIndex={currentSlideIndex}
                      selectedSlide={{
                        assetId: selectedSlide.assetId,
                        slideIds: validSlides.map((slide) => slide.id),
                        slidenums: validSlides.map((slide) => slide.name),
                        signedUrls: validSlides.map((slide) => ({
                          pageId: slide.id,
                          signedUrl: slide.signedUrl,
                        })),
                      }}
                      isPreviewOpen={isPreviewOpen}
                      singleSlideMode={true}
                    />
                  </div>
                ) : (
                  <div className={styles.previewbox}>
                    {currentSlide?.moduleData ? (
                      <ModulePreviewData
                        isSlide={true}
                        modulePreviewData={currentSlide.moduleData}
                        hideMustUseLabels={true}
                      />
                    ) : (
                      <div className="d-flex justify-content-center align-items-center w-100 h-100">
                        <span className="text-muted">
                          No module data available for this slide
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Bottom buttons */}
        <article className={styles.modalBottom}>
          <div></div>
          <div></div>
          <div>
            <PrimaryButton
              fontSize="12px"
              title="CONTINUE"
              handleClick={() => {
                onClose();
                setAnalyseModal(true);
              }}
              disabled={validSlides.length === 0}
            />
          </div>
        </article>
      </div>
    </div>
  );
};

export const ElementPreviewSlides = React.memo(
  ElementPreviewSlidesComponent,
  (prevProps, nextProps) =>
    prevProps.messageId === nextProps.messageId &&
    prevProps.show === nextProps.show &&
    prevProps.modulesData === nextProps.modulesData &&
    prevProps.selectedSlide === nextProps.selectedSlide,
);

const AnalysePreviewSlidesComponent = ({
  show,
  onClose,
  setAnalyseModal,
  setShowCmsddata,
  selectedSlide,
  modulesData,
  setShowModuleAssembly,
}) => {
  const [matchedData, setMatchedData] = React.useState({
    slides: [],
    modules: [],
  });

  // Check if we should show the modal at all
  const shouldShowModal = React.useMemo(() => {
    if (!show || !selectedSlide || !modulesData) return false;

    const moduleMap = {};
    modulesData.forEach((mod) => {
      moduleMap[mod.slideId] = mod;
    });

    return selectedSlide.slideIds?.some((slideId) => {
      const module = moduleMap[slideId];
      const signedUrlObj = selectedSlide.signedUrls?.find(
        (item) => item.pageId === slideId,
      );
      return module && signedUrlObj;
    });
  }, [show, selectedSlide, modulesData]);

  React.useEffect(() => {
    if (!shouldShowModal) return;

    // Create map of slideId to module for quick lookup
    const moduleMap = {};
    modulesData.forEach((mod) => {
      moduleMap[mod.slideId] = mod;
    });

    // Filter and match slides with modules
    const validSlides = [];
    const validModules = [];

    (selectedSlide?.slidenums || []).forEach((slidenum, index) => {
      const slideId = selectedSlide?.slideIds?.[index];
      const module = moduleMap[slideId];
      const signedUrlObj = selectedSlide?.signedUrls?.find(
        (item) => item.pageId === slideId,
      );

      if (module && signedUrlObj) {
        validSlides.push({
          slideLabel: slidenum,
          signedUrl: signedUrlObj.signedUrl,
          pageId: signedUrlObj.pageId,
        });

        validModules.push({
          id: module.id || `module${validModules.length + 1}`,
          name: module.name || `Module ${validModules.length + 1}`,
        });
      }
    });

    setMatchedData({
      slides: validSlides,
      modules: validModules,
    });
  }, [shouldShowModal, selectedSlide, modulesData]);

  // Don't render anything if we shouldn't show the modal
  if (!shouldShowModal) return null;

  return (
    <div className={styles.analysemodalOverlay} onClick={onClose}>
      <div
        className={styles.analysemodalContent}
        onClick={(e) => e.stopPropagation()}
      >
        <article className={styles.modalHead}>
          <span className={styles.analysehead}>
            <strong>Selected slides for module creation</strong>
          </span>
        </article>

        <article className={styles.moduleboxcont}>
          <span className={styles.moduleleftcont}>Selected Slides</span>
          <span className={styles.modulerightcont}>Modules</span>
        </article>

        <div className={styles.moduleboxcenter}>
          {/* Left: Slides */}
          <article className={styles.analyseright}>
            {matchedData.slides.map((slide, i) => (
              <div key={slide.pageId || i} className={styles.analyseborderBox}>
                <span className={styles.analysebox}>
                  <img
                    className={styles.imgSlidecont}
                    src={slide.signedUrl}
                    alt={slide.slideLabel}
                  />
                  <span className={styles.analyseText}>{slide.slideLabel}</span>
                </span>
              </div>
            ))}
          </article>

          {/* Right: Modules */}
          <article className={styles.analyseleft}>
            {matchedData.modules.map((mod) => (
              <div key={mod.id} className={styles.analyseborderBox}>
                <span className={styles.analysebox}>
                  <img src={moduleimage} alt="module" />
                  <span className={styles.analyseText}>{mod.name}</span>
                </span>
              </div>
            ))}
          </article>
        </div>

        <article className={styles.analyseModalBottom}>
          <div></div>
          <div></div>
          <div>
            <PrimaryButton
              fontSize="12px"
              title="CONTINUE"
              handleClick={() => {
                onClose();
                setShowModuleAssembly(true);
              }}
            />
          </div>
        </article>
      </div>
    </div>
  );
};

export const AnalysePreviewSlides = React.memo(
  AnalysePreviewSlidesComponent,
  (prevProps, nextProps) =>
    prevProps.messageId === nextProps.messageId &&
    prevProps.show === nextProps.show,
);

export const GenarateCMSD = ({
  show,
  onClose,
  setShowCmsd,
  setSendCMSD,
  moduleIds, // ALL module IDs from parent
  selectedModules,
  createdModules,
  selectedSlide,
  onEditModule,
  edetailDetails,
  multiModuleCreation,
  multipleModulesData,
}) => {
  const [activeModuleIndex, setActiveModuleIndex] = useState(0);
  const [moduleData, setModuleData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [moduleDetails, setModuleDetails] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [modules, setModules] = useState([]); // Modules to display in tabs

  // Function to get created modules for display
  const getCreatedModules = () => {
    const createdModulesList = [];

    if (!moduleIds || Object.keys(moduleIds).length === 0) {
      return createdModulesList;
    }

    if (multiModuleCreation && multipleModulesData?.length) {
      // For multi-module creation
      for (let i = 0; i < multipleModulesData.length; i++) {
        const moduleKey = `module_${i + 1}`;
        const moduleId = moduleIds[moduleKey];

        // Only include if module is created
        if (moduleId && createdModules?.[i]) {
          createdModulesList.push({
            id: `Module_${i + 1}`,
            moduleId: moduleId,
            name: multipleModulesData[i]?.moduleNumber || `Module_${i + 1}`,
            originalIndex: i,
            type: "multi",
            // Add thumbnail if available
            thumbnail: multipleModulesData[i]?.thumbnail || null,
            slideName: multipleModulesData[i]?.slideName || `Module ${i + 1}`,
          });
        }
      }
    } else if (selectedSlide?.slideIds?.length) {
      // For regular flow
      for (let i = 0; i < selectedSlide.slideIds.length; i++) {
        const slideId = selectedSlide.slideIds[i];
        const moduleId = moduleIds[slideId];

        // Only include if module is created
        if (moduleId && createdModules?.[i]) {
          createdModulesList.push({
            id: `Module_${i + 1}`,
            moduleId: moduleId,
            name: `Module_${i + 1}`,
            originalIndex: i,
            slideId: slideId,
            type: "regular",
            // Add slide image if available
            thumbnail: selectedSlide?.signedUrls?.[i]?.signedUrl || null,
            slideName: selectedSlide?.slidenums?.[i] || `Slide ${i + 1}`,
          });
        }
      }
    }

    return createdModulesList;
  };

  // Initialize when component shows
  useEffect(() => {
    if (!show) return;

    // Get created modules for display
    const createdModulesList = getCreatedModules();

    setModules(createdModulesList);

    // Reset state
    setActiveModuleIndex(0);
    setModuleData({});
    setModuleDetails({});
    setError(null);
    setLoading(false);

    // If no created modules, show error
    if (createdModulesList.length === 0) {
      setError(
        "No modules have been created yet. Please create modules first.",
      );
      return;
    }

    // Fetch details for the first created module
    if (createdModulesList[0]?.moduleId) {
      fetchModuleDetails(createdModulesList[0].moduleId, 0);
    }
  }, [
    show,
    moduleIds,
    selectedModules,
    createdModules,
    multiModuleCreation,
    multipleModulesData,
  ]);

  // When active module changes, fetch details for that module
  useEffect(() => {
    if (!show || modules.length === 0) return;

    const currentModule = modules[activeModuleIndex];
    if (
      currentModule &&
      currentModule.moduleId &&
      !moduleDetails[activeModuleIndex]
    ) {
      fetchModuleDetails(currentModule.moduleId, activeModuleIndex);
    }
  }, [activeModuleIndex, show, modules]);

  // Function to fetch module details
  const fetchModuleDetails = (moduleId, moduleIndex) => {
    if (!moduleId || moduleDetails[moduleIndex]) return;

    setLoading(true);
    setError(null);

    import("services/apis")
      .then(({ fetchModuleDetails }) => {
        fetchModuleDetails(moduleId, (response, error) => {
          if (response && response.data) {
            setModuleDetails((prev) => ({
              ...prev,
              [moduleIndex]: response.data,
            }));

            setModuleData((prev) => ({
              ...prev,
              [moduleIndex]: response.data,
            }));
          } else {
            console.error(
              `Error fetching module details for moduleId ${moduleId}:`,
              error,
            );
            setError(
              `Failed to load module details: ${error?.message || "Unknown error"}`,
            );

            // If module not found, remove it from the list
            if (error?.response?.status === 404) {
              setModules((prev) =>
                prev.filter((_, idx) => idx !== moduleIndex),
              );
              if (activeModuleIndex >= moduleIndex) {
                setActiveModuleIndex(Math.max(0, activeModuleIndex - 1));
              }
            }
          }
          setLoading(false);
        });
      })
      .catch((err) => {
        console.error("Failed to load API module:", err);
        setError("Failed to load module service");
        setLoading(false);
      });
  };

  // Get the current module ID for editing
  const getCurrentModuleId = () => {
    if (modules.length > 0 && activeModuleIndex < modules.length) {
      return modules[activeModuleIndex]?.moduleId || null;
    }
    return null;
  };

  if (!show) return null;

  return (
    <div className={styles.modalOverlay} onClick={() => {}}>
      <div
        className={styles.modalContent}
        style={{ width: "1085px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <article className={styles.modalHead}>
          <div>
            {modules.length > 0 ? (
              <div
                className={styles.MEMHeadBox}
                style={{ borderBottom: "none" }}
              >
                <span>CMSD PREVIEW</span>
              </div>
            ) : (
              <div className="p-3 text-center">
                <span className="text-muted">No created modules available</span>
              </div>
            )}
          </div>
        </article>

        {/* Main content area - Left-Right Layout */}
        <div className={styles.MEMBoxMain}>
          {/* Left side - Module tabs */}
          <div className={styles.leftMEM} style={{ padding: 0 }}>
            {modules.length > 0 && (
              <div className={styles.contASlideAnalyse}>
                {modules.map((module, index) => {
                  const isSelected = activeModuleIndex === index;
                  const moduleImage = module.thumbnail;

                  //  const moduleName = `Module_${index + 1}`; // Always use array index

                  return (
                    <div
                      key={module.id}
                      className={`${styles.fullBOX} ${
                        isSelected ? styles.selectedSlide : ""
                      }`}
                      onClick={() => {
                        if (!loading) {
                          setActiveModuleIndex(index);
                        }
                      }}
                    >
                      <div
                        className={`${styles.sliderecBoxAnalyse} ${
                          isSelected ? styles.activeModule : ""
                        }`}
                      >
                        <span className={styles.analyseboxOne}>
                          <span className={styles.analyseTextMEM}>
                            {module.name}
                          </span>
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Right side - Module preview */}
          <div className={styles.rightMEM} style={{ padding: 0 }}>
            <div className={styles.cmsdouterpreviewBox}>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center w-100 h-100">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : error ? (
                <div className="d-flex justify-content-center align-items-center w-100 h-100">
                  <div className="text-danger p-3">
                    <strong>Error:</strong> {error}
                  </div>
                </div>
              ) : modules.length === 0 ? (
                <div className="d-flex justify-content-center align-items-center w-100 h-100">
                  <span className="text-muted">
                    No modules have been created yet. Please go back and create
                    modules first.
                  </span>
                </div>
              ) : moduleData[activeModuleIndex] ? (
                <div>
                  <ModulePreviewData
                    modulePreviewData={moduleData[activeModuleIndex]}
                    edtInfo={{ showEdt: true, edetailDetails: edetailDetails }}
                  />
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center w-100 h-100">
                  <span className="text-muted">
                    {getCurrentModuleId()
                      ? "Loading module details..."
                      : "Module data not available"}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Bottom buttons */}
        <article className={styles.modalBottom}>
          {modules.length > 0 && (
            <div
              className={styles.cmsdedittext}
              onClick={() => setShowConfirmModal(true)}
            >
              EDIT MODULE
            </div>
          )}
          <div></div>
          <div>
            <PrimaryButton
              fontSize="12px"
              title="GO TO MODULE DASHBOARD"
              handleClick={() => setSendCMSD(true)}
              disabled={modules.length === 0}
            />
          </div>
        </article>

        {/* Confirmation Modal */}
        <CustomModal
          displayModal={showConfirmModal}
          hideModal={() => setShowConfirmModal(false)}
          size="sm"
          dilogClassName="alertModalSmall"
        >
          <ConfirmationPopup
            title="Confirmation"
            text="If you proceed to edit this module, you will not be able to return to Gen AI with the existing data."
            closeModal={() => setShowConfirmModal(false)}
            handleConfirm={() => {
              setShowConfirmModal(false);
              if (onEditModule) {
                const currentModuleId = getCurrentModuleId();
                onEditModule(
                  activeModuleIndex,
                  currentModuleId,
                  moduleData[activeModuleIndex],
                );
              } else {
                setShowCmsd(false);
              }
            }}
            primaryButtonTitle="PROCEED"
          />
        </CustomModal>
      </div>
    </div>
  );
};
